import React, { Component } from 'react';
import SearchServices from './SearchServiceIdComponent'
import { actions } from './SearchServiceIdReducer'
import { connect } from 'react-redux'

class Wrapper extends Component {
    componentDidMount() {   
        
    }
    render() {
        return (
            <React.Fragment>
                <SearchServices {...this.props} />                
            </React.Fragment>
        )
    }
}

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        search: (searchPhrase) => dispatch(actions.search(searchPhrase))
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        loading: state.waas.searchServiceById.fetcher.loading,
        results: state.waas.searchServiceById.fetcher.items.results || [],
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Wrapper);